import React, { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cx from 'classnames';
import MenuIcon from '@material-ui/icons/Menu';
import BoxModal from '@components/BoxModal';
import { useTranslation } from 'next-i18next';
import _get from 'lodash/get';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 90,
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    margin: '0 -20px',
    padding: '10px 20px 8px 20px',
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      margin: 'initial',
    },
  },
  categories: {
    display: 'flex',
    flexDirection: 'column',
  },
  categoryContainer: {
    border: '1px solid #ddd',
    borderRadius: 4,
    padding: 8,
    marginBottom: 8,
    width: '100%',
  },
  categoryContainerSelected: {
    borderColor: theme.palette.primary.main,
  },
  header: {
    display: 'flex',
  },
  headerLabel: {
    textAlign: 'center',
    flex: 2,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 4px',
  },
}));

const CategoryTabsWithModal = ({
  categories = [],
  setCurrentCategorySlug,
  setKeyword,
  currentCategorySlug,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [categoryLabel, setCategoryLabel] = useState('');

  useEffect(() => {
    if (categories.length > 0 && currentCategorySlug) {
      const res = categories.filter(category => category.slug === currentCategorySlug);
      if (res.length > 0) {
        setCategoryLabel(_get(res, '0.label'));
      }
    }
  }, [categories, currentCategorySlug]);

  return (
    <div className={classes.root}>
      <div className={classes.header} onClick={() => setIsOpenModal(true)}>
        <MenuIcon />
        <div className={classes.headerLabel}>{categoryLabel}</div>
      </div>
      <BoxModal
        open={isOpenModal}
        heading={t('categories')}
        handleClose={() => setIsOpenModal(false)}
      >
        <p>{t('please-select-to-see-other-categories-product')}</p>
        <div className={classes.categories}>
          {categories &&
            categories.length > 0 &&
            categories.map(({ slug, label }, i) => (
              <div
                href={`#${slug}`}
                key={i}
                onClick={() => {
                  setKeyword('');
                  setCurrentCategorySlug(slug);
                  setIsOpenModal(false);
                  window.history.pushState(null, null, `${window.location.pathname}#${slug}`);
                  document.getElementById('search-bar').scrollIntoView();
                }}
                className={cx(classes.categoryContainer, {
                  [classes.categoryContainerSelected]: currentCategorySlug === slug,
                })}
              >
                <span className={classes.categoryTabLabel}>{label}</span>
              </div>
            ))}
        </div>
      </BoxModal>
    </div>
  );
};

export default CategoryTabsWithModal;
